import React from 'react';
import PropTypes from 'prop-types';
import './style.less';

class Report extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };

  state = {
  };

  componentDidMount() {
    // this.init();
  }

  returnScores = (type, num) => {
    const items = [];
    for (let i = 0; i < num; i += 1) {
      if (type === 'grey') {
        items.push(<div key={`diamond${i}`} className="finished" />);
      } else if (type === 'golder') {
        items.push(<div key={`diamond${i}`} className="finish" />);
      } else {
        items.push(<div key={`diamond${i}`} className="unfinish" />);
      }
    }
    return items;
  }

  render() {
    const { data } = this.props;
    return (
      <div className="report-wrapper">
        {data
          && (
            <div className="report">
              <div className="reading-scores">
                <div className="title">Reading Scores</div>
                {this.returnScores('grey', data.read.greyDiamonds)}
                {this.returnScores('golder', data.read.golderDiamonds)}
                {this.returnScores('empty', data.read.emptyDiamonds)}
              </div>
              <div className="quiz-scores">
                <div className="title">Quiz Scores</div>
                {this.returnScores('grey', data.quiz.greyDiamonds)}
                {this.returnScores('golder', data.quiz.golderDiamonds)}
                {this.returnScores('empty', data.quiz.emptyDiamonds)}
              </div>
              <div className="sharing-scores">
                <div className="title">Sharing Scores</div>
                {this.returnScores('grey', data.share.greyDiamonds)}
                {this.returnScores('golder', data.share.golderDiamonds)}
                {this.returnScores('empty', data.share.emptyDiamonds)}
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

export default Report;
